"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _Header = _interopRequireDefault(require("../../components/Header"));
var _Formula = _interopRequireDefault(require("./Formula"));
var _Flags = _interopRequireDefault(require("./Flags"));
var _admin = require("../../selectors/admin.js");
var _Exports = _interopRequireDefault(require("./Exports"));
var _MetricTypeDropdown = _interopRequireDefault(require("../../components/Header/MetricTypeDropdown"));
var _payload = _interopRequireDefault(require("./Formula/payload"));
var _processFormulaChanges = _interopRequireDefault(require("./processFormulaChanges"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Boilerplate = window.cccisd.boilerplate;
var _default = exports["default"] = function _default(props) {
  var assignment = props.assignment,
    data = props.data,
    elementIcons = props.elementIcons,
    loadData = props.loadData,
    metricFilter = props.metricFilter,
    tableActualFilter = props.tableActualFilter,
    renderDefault = props.renderDefault,
    setIsUpdated = props.setIsUpdated,
    setMetricFilter = props.setMetricFilter,
    surveyHandles = props.surveyHandles,
    downloadCsv = props.downloadCsv,
    setLoading = props.setLoading,
    surveyDropdownVisible = props.surveyDropdownVisible,
    setSurveyDropdownVisible = props.setSurveyDropdownVisible,
    metricTypeDropdownVisible = props.metricTypeDropdownVisible,
    setMetricTypeDropdownVisible = props.setMetricTypeDropdownVisible;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    saving = _useState2[0],
    setSaving = _useState2[1];
  var currentAssignmentId = (0, _reactRedux.useSelector)(function (state) {
    return state.assignment.admin.currentAssignmentId;
  });
  var restrictionsLevel = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getRestrictionsLevel)(state.assignment.admin);
  });
  var initialValues = {};
  var _iterator = _createForOfIteratorHelper(data),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var row = _step.value;
      initialValues["variable".concat(row.variableId)] = row.reportHeader;
      initialValues["label".concat(row.variableId)] = row.label || '';
      initialValues["isIdentifying".concat(row.variableId)] = row['key.isIdentifying'] || false;
      initialValues["devTags".concat(row.variableId)] = row.tagList.map(function (item) {
        return item.name || item.handle;
      }); // name for app-definitions < 17.1.0, label >= 17.1.0
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var initialValuesHash = data.map(function (row) {
    return row.variableId;
  }).join('_');
  var validate = function validate(values) {
    var errors = {};
    var _iterator2 = _createForOfIteratorHelper(data),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var row = _step2.value;
        var varField = "variable".concat(row.variableId);
        if (!values[varField]) {
          errors[varField] = 'Variable name is required';
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return errors;
  };
  var onSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(values) {
      var changedValues, _iterator3, _step3, row, variableId, label, changedFormulas, response, errors, _i, _Object$entries, _Object$entries$_i, key, value;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            changedValues = [];
            _iterator3 = _createForOfIteratorHelper(data);
            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                row = _step3.value;
                variableId = row.variableId;
                label = row.label || ''; // convert null to empty string
                if (row.reportHeader !== values["variable".concat(variableId)] || label !== values["label".concat(variableId)] || row['key.isIdentifying'] !== values["isIdentifying".concat(variableId)] || !(0, _isEqual2["default"])(row.tagList.map(function (item) {
                  return item.name;
                }), values["devTags".concat(variableId)])) {
                  changedValues.push({
                    variableId: variableId,
                    reportHeader: values["variable".concat(variableId)],
                    label: values["label".concat(variableId)],
                    isIdentifying: values["isIdentifying".concat(variableId)],
                    devTags: values["devTags".concat(variableId)]
                  });
                }
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
            if (!(changedValues.length === 0)) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            _context.n = 2;
            return (0, _processFormulaChanges["default"])(changedValues, data, currentAssignmentId, setLoading);
          case 2:
            changedFormulas = _context.v;
            setSaving(true);
            _context.n = 3;
            return _cccisdAxios["default"].put(Boilerplate.route('api.metrics.variable.bulkUpdate'), {
              variables: changedValues,
              changedFormulas: changedFormulas
            });
          case 3:
            response = _context.v;
            if (!(response.data.status === 'error')) {
              _context.n = 4;
              break;
            }
            errors = {};
            for (_i = 0, _Object$entries = Object.entries(response.data.error); _i < _Object$entries.length; _i++) {
              _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];
              if (value.reportHeader) {
                errors["variable".concat(key)] = value.reportHeader;
              }
            }
            setSaving(false);
            (0, _cccisdNotification["default"])({
              message: 'You have to fix variable names',
              type: 'danger'
            });
            return _context.a(2, Promise.reject(errors));
          case 4:
            _context.n = 5;
            return loadData();
          case 5:
            setSaving(false);
          case 6:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var getUpdatedFields = function getUpdatedFields(values) {
    return Object.keys(values).filter(function (key) {
      var tiv = _typeof(initialValues[key]);
      var tv = _typeof(values[key]);
      if (tiv === 'object' && tv === 'object' && Array.isArray(initialValues[key]) && Array.isArray(values[key])) {
        var va = values[key].concat().sort();
        var ia = initialValues[key].concat().sort();
        return !(0, _isEqual2["default"])(va, ia);
      }
      return !(0, _isEqual2["default"])(initialValues[key], values[key]);
    });
  };
  var addFormula = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(values) {
      var postData, response;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            postData = _objectSpread(_objectSpread({}, (0, _payload["default"])(values)), {}, {
              assignmentId: currentAssignmentId
            });
            _context2.n = 1;
            return _cccisdAxios["default"].post(Boilerplate.route('api.metrics.formula.store'), postData);
          case 1:
            response = _context2.v;
            if (!(response.data.status === 'success')) {
              _context2.n = 3;
              break;
            }
            _context2.n = 2;
            return loadData();
          case 2:
            (0, _cccisdNotification["default"])('Formula has been successfully added');
            _context2.n = 4;
            break;
          case 3:
            return _context2.a(2, Promise.reject({
              reportHeader: Object.values(response.data.errors).map(function (item) {
                return item.join(', ');
              }).join(', ')
            }));
          case 4:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function addFormula(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    key: initialValuesHash,
    initialValues: initialValues,
    validate: validate,
    onSubmit: onSubmit,
    render: function render(_ref3) {
      var handleSubmit = _ref3.handleSubmit,
        values = _ref3.values,
        errors = _ref3.errors,
        setFieldValue = _ref3.setFieldValue;
      var updatedFields = getUpdatedFields(values);
      var isUpdated = updatedFields.length > 0;
      setIsUpdated(isUpdated);
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginBottom: '1em'
        }
      }, /*#__PURE__*/_react["default"].createElement(_Header["default"], {
        showProjectDropdown: true,
        showQuestCount: false,
        showQuestDropdown: true,
        allowAllQuests: false,
        showSurveyDropdown: true,
        surveyDropdownVisible: surveyDropdownVisible,
        setSurveyDropdownVisible: setSurveyDropdownVisible,
        leftSection: /*#__PURE__*/_react["default"].createElement(_MetricTypeDropdown["default"], {
          metricTypeDropdownVisible: metricTypeDropdownVisible,
          setMetricTypeDropdownVisible: setMetricTypeDropdownVisible,
          metricFilter: metricFilter,
          setMetricFilter: setMetricFilter,
          isUpdated: isUpdated
        }),
        rightSection: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, restrictionsLevel !== 'basic' && /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
          title: "Flags",
          size: "large",
          trigger: /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
            type: "button",
            className: "btn btn-secondary",
            title: "Manage flags",
            style: {
              marginRight: '0.5em'
            }
          })
        }, /*#__PURE__*/_react["default"].createElement(_Flags["default"], null)), restrictionsLevel !== 'basic' && /*#__PURE__*/_react["default"].createElement(_Exports["default"], {
          assignment: assignment,
          surveyHandles: surveyHandles,
          typeFilter: metricFilter,
          filter: tableActualFilter,
          elementIcons: elementIcons,
          downloadCsv: downloadCsv
        }), restrictionsLevel !== 'basic' && /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
          title: "Add formula",
          size: "large",
          trigger: /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
            type: "button",
            className: "btn btn-secondary",
            title: "Add formula",
            style: {
              marginRight: '0.5em'
            }
          })
        }, /*#__PURE__*/_react["default"].createElement(_Formula["default"], {
          onSubmit: addFormula
        })), /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
          type: "button",
          className: "btn ".concat(isUpdated ? 'btn-warning' : 'btn-secondary'),
          onClick: handleSubmit,
          isLoading: saving,
          title: "Save"
        }))
      })), currentAssignmentId === 0 ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "alert alert-danger"
      }, "There are no assignments for current project") : renderDefault({
        values: values,
        initialValues: initialValues,
        errors: errors
      }));
    }
  });
};